import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileSidebar } from './sidebar';
import { Navbar } from './navbar';
import { useAppAuth } from '@/providers/use-app-auth';

/**
 * Layout principal da aplicação com sidebar e navbar
 */
export function AppLayout() {
  const { user } = useAppAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const role = user?.role ?? 'administrator';
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);
  const openMobileMenu = useCallback(() => setMobileMenuOpen(true), []);

  return (
    <div className="flex h-dvh overflow-hidden bg-background">
      <Sidebar role={role} />
      <MobileSidebar
        role={role}
        open={mobileMenuOpen}
        onClose={closeMobileMenu}
      />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Navbar onMenuClick={openMobileMenu} />
        <main className="flex-1 overflow-y-auto overscroll-y-contain p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
